import { AfterViewInit, Component, input, model, output, ViewChild } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { Approval } from '../../../core/types';
import { timer } from 'rxjs';
import { TranslocoModule } from '@jsverse/transloco';

export function getStatusColor(approval: Approval): string {
  if (approval === 'Dormant') {
    return 'badge-dormant';
  }

  if (approval === 'Edit') {
    return 'badge-edit';
  }

  if (approval === 'Pending') {
    return 'badge-pending';
  }

  if (approval === 'Live') {
    return 'badge-live';
  }

  return '';
}

export function getStatusText(approval: Approval): string {
  if (approval === 'Dormant') {
    return 'state_inactive';
  }

  if (approval === 'Edit') {
    return 'state_in_progress';
  }

  if (approval === 'Pending') {
    return 'state_approval';
  }

  if (approval === 'Live') {
    return 'state_active';
  }

  return 'Unbekannter Status';
}

@Component({
  selector: 'pixl-state-cb',
  imports: [
    MatSelectModule,
    TranslocoModule
  ],
  templateUrl: './state-cb.component.html',
  styleUrl: './state-cb.component.scss'
})
export class StateFilterCBComponent implements AfterViewInit {
  @ViewChild('select') select!: HTMLSelectElement;

  withEmptyOption = input<boolean>(false); // Should '---' displayed in options list?
  required = input<boolean>(false);
  isEmpty = false;
  initValue = model<string>(''); // Possible init value
  onStateChange = output<string>();

  public ngAfterViewInit(): void {
    timer(0).subscribe(() => {
      if (this.select) {
        const initial = this.initValue() ?? '';
        this.select.value = initial;
      }
    });
  }

  public onChangeEvent(ev: string): void {
    this.validateValue(ev);
    this.onStateChange.emit(ev);
  }

  private validateValue(value: string): void {
    this.isEmpty = this.required() && !value;
  }

  public validate(): boolean {
    const value = this.select?.value ?? '';
    this.validateValue(value);
    return !this.isEmpty;
  }
}
